export const TermsAndConditionsOfUseConfig = "termsAndConditionsOfUse";
